import { UpdateCardTitle } from "../../../store/actions";

import * as storymapStoreModule from '../../../store';
import { CardType, ChangeCardName } from "..";
import { getCardType } from "./use";
import { getCardById } from "../../../store/use";
import { uuid } from "@/_core/utils/uuid";
import { BoardUserActivityType } from "@/api/workspaceSettings/queries";

export const createChangeCardNameCommand = async (action: UpdateCardTitle) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.id);
    const cardType = getCardType(card);

    const cmd = new ChangeCardName(action.id, state.id, action.title, cardType);
    const activityId = await uuid.create();

    const activity = {
        CardId: card.id,
        CardName: action.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        OriginalContent: card.title,
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: getActivityType(cardType),
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
}


const getActivityType = (cardType: CardType) => {
    switch (cardType) {
        case CardType.Activity:
            return BoardUserActivityType.ActivityNameChanged;
        case CardType.Task:
            return BoardUserActivityType.TaskNameChanged;
        case CardType.Subtask:
            return BoardUserActivityType.SubtaskNameChanged;
        case CardType.UnscheduledSubtask:
            return BoardUserActivityType.UnscheduledSubtaskNameChanged;
    }
}
